import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export type News = {
	id: string;
	title: string;
	content: any;
	imageUrl?: string;
	publishAt: Date;
};

export default function NewsList() {
	const [news, setNews] = useState<News[]>([]);

	async function fetchNews() {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/news`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		});

		const data = await res.json();

		if (!res.ok) {
			console.error(data.message);
			return;
		}

		setNews(data);
	}

	async function deleteNews(id: string) {
		const res = await fetch(`${process.env.REACT_APP_API_URL}/news/${id}`, {
			method: 'DELETE'
		});

		if (!res.ok) {
			const data = await res.json();
			console.error(data.message);
		}

		fetchNews();
	}

	useEffect(() => {
		fetchNews();
	}, []);

	return (
		<div>
			<h1>News</h1>
			<div className="news container container-lg" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
				{news.map((newsPost) => {
					return (
						<div key={newsPost.id} className={'news'} style={{ border: "1px solid", borderColor: "black", borderRadius: "5px", margin: 5, padding: 5, width: "50%" }} >
							<div className={'title'}>{newsPost.title}</div>
							{newsPost.imageUrl &&
								<div className={'imageUrl'}>
									<img width={300} src={newsPost.imageUrl} alt={newsPost.title} />
								</div>
							}
							<Link to={{ pathname: "/news/" + newsPost.id }}><Button variant="primary">Edit</Button></Link>
							<Button variant="danger" onClick={() => deleteNews(newsPost.id)}>Delete</Button>
						</div>
					);
				})}
			</div>
			<Link to="/newNews"><Button>Create</Button></Link>
		</div>
	);
}
